<template>
  <div>
    <app-detail-header :title="'Subscriptions'" :sub-title="''"></app-detail-header>

    <div class="row" style="margin: 10px">
      <div class="col-md-12">
        <div class="box box-default">
          <div class="box-header with-border">
            <h3 class="box-title">
              <i class="fa fa-history"></i> Most Recent Subscription Activations
            </h3>
          </div>
          <div class="box-body">
            <div v-if="recentLoading" class="text-muted mb-2">
              <i class="fa fa-refresh fa-spin"></i> Loading recent activity...
            </div>
            <table
              class="table table-bordered table-striped"
              v-if="recentTransactions.length > 0"
            >
              <thead>
                <tr>
                  <th>Activity</th>
                  <th>Partner</th>
                  <th>Party</th>
                  <th>Email</th>
                  <th>Transaction Type</th>
                  <th>Activated Date</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in recentTransactions"
                  :key="'recent-sub-' + (item.activationCodeId || item.activatedDate)"
                >
                  <td>Subscription Activated</td>
                  <td>{{ item.partnerId || "—" }}</td>
                  <td>{{ item.partyName || "—" }}</td>
                  <td>{{ item.partyEmail || "—" }}</td>
                  <td>{{ item.transactionType || "—" }}</td>
                  <td>{{ formatDate(item.activatedDate) }}</td>
                </tr>
              </tbody>
            </table>
            <div v-else class="text-center text-muted" style="padding: 20px">
              <i
                class="fa fa-history"
                style="font-size: 24px; margin-bottom: 10px"
              ></i>
              <p>No recent subscription activations found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <appFilter></appFilter>
      </div>
      <div class="col-md-9">
        <appResult></appResult>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios/index";
import authHeader from "../../authHeader";
import SubscriptionFilter from "../../components/paywall/subscription/SubscriptionFilter";
import SubscriptionResult from "../../components/paywall/subscription/SubscriptionResult";

export default {
  data() {
    return {
      recentLoading: false,
      recentTransactions: [],
    };
  },
  mounted() {
    this.fetchRecentTransactions();
  },
  components: {
    appFilter: SubscriptionFilter,
    appResult: SubscriptionResult,
  },
  methods: {
    fetchRecentTransactions() {
      this.recentLoading = true;
      axios({
        method: "GET",
        url: "/activationCode/manage/recent",
        params: { limit: 10 },
        headers: authHeader(),
      })
        .then((res) => {
          this.recentTransactions = Array.isArray(res.data) ? res.data : [];
        })
        .catch((err) => {
          console.log(err);
          this.recentTransactions = [];
        })
        .finally(() => {
          this.recentLoading = false;
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return "—";
      return new Date(dateStr).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/party/SubscriptionPanel.vue